import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import {getDiamondImage, formatDiamondTitle, formatMeasurements, formatLocation, formatCut, formatCarat, formatCost, formatColor, formatPrice, formatClarity} from '../../../utils/formatting';

import * as messagesActionCreators from '../../../actions/messages';
import * as usersActionCreators from '../../../actions/users';
let allActionCreators = Object.assign({}, messagesActionCreators, usersActionCreators);

class NewMessage extends React.Component {

	constructor(props) {
		super(props);

    this.state = {
      recipients: [],
      
      recipientInput: '',
      messageBody: '',

      errorRecipient: null,
      errorMessage: null,      

      displayInput: this.props.messages.selectedRecipient === null,
      displayAutocomplete: false,
      autocompleteUsers: [],

      serverError: null,
      sendingRequest: false,
    }

    // Fetch user messages
    if(this.props.messages.userMessages === null) {
      this.props.fetchUserMessages()
      .then((respData) => {
        this.props.messagesSave(respData.messages);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in
        // console.error(errorResp);
      });      
    }

    // Fetch user directory
    if(this.props.messages.directory === null) {
      this.props.fetchUserDirectory()
      .then((respData) => {
        this.props.messagesSaveDirectory(respData.users);
      })
      .catch((errorResp) => {
        // Do nothing; expected error if not logged in
        // console.error(errorResp);
      });      
    }
	}

  closeDropdown() {
    this.props.messagesCloseNewDropdown();
  }

  getRootClass() {
    return this.props.messages.newDropdownOpen ? 'NewMessage open' : 'NewMessage';
  }

  setAutocomplete() {
    let suggestions = [];
    for(let i = 0; i < this.props.messages.directory.length; i++) {

      let inputLower = this.state.recipientInput.toLowerCase();

      let firstLower = this.props.messages.directory[i].first_name.toLowerCase();
      let lastLower = this.props.messages.directory[i].last_name.toLowerCase();
      let nameLower = firstLower + ' ' + lastLower;
      let emailLower = this.props.messages.directory[i].email.toLowerCase();

      if(inputLower === '' || firstLower.includes(inputLower) || lastLower.includes(inputLower) || nameLower.includes(inputLower) || emailLower.includes(inputLower)) {
        suggestions.push(this.props.messages.directory[i]);
      }
    }
    this.setState({ autocompleteUsers: suggestions });
  }

  changeRecipientInput(evt) {
    this.setState({ recipientInput: evt.target.value }, () => {
      this.setAutocomplete();
    });
  }

  changeMessage(evt) {
    this.setState({ messageBody: evt.target.value }, () => {
      if(this.state.errorMessage && this.state.messageBody) {
        this.setState({ errorMessage: null });
      }
    });
  }

  validateRecipientInput(evt) {
    if(this.state.recipients.length === 0) {
      this.setState({
        errorRecipient: 'Please select a user',  
      });
    }
  }

  validateMessage(evt) {
    if(this.state.messageBody.trim() === '') {
      this.setState({
        errorMessage: 'Please enter a message',  
      });
    }
  }

  openAutocomplete() {
    this.setState({ displayAutocomplete: true }, () => {
      this.setAutocomplete();
    });
  }

  closeAutocomplete() {
    this.setState({ displayAutocomplete: false }); 
  }

  selectRecipient(user) {

    let alreadySelected = false;
    for(let i = 0; i < this.state.recipients.length; i++) {
      if(this.state.recipients[i].id === user.id) {
        alreadySelected = true;
      }
    }

    let newRecipients = [];
    for(let i = 0; i < this.state.recipients.length; i++) {
      newRecipients.push(this.state.recipients[i]);
    }

    if(!alreadySelected) {
      newRecipients.push(user);
    }

    this.setState({
      recipients: newRecipients,
      displayInput: false,
      recipientInput: '',
      displayAutocomplete: false,
      errorRecipient: null,
    });
  }

  showInput() {
    this.setState({ displayInput: true });
  }

  removeRecipient(recipient) {
    
    let newRecipients = [];
    for(let i = 0; i < this.state.recipients.length; i++) {
      if(this.state.recipients[i].id !== recipient.id) {
        newRecipients.push(this.state.recipients[i]);
      }
    }

    this.setState({
      recipients: newRecipients,
    }, () => {
      if(this.state.recipients.length === 0) {
        this.showInput();
      }
    });
  }

  validateAll() {
    let hasErrors = true;
    
    // Required params
    let errorRecipient = null;

    if(this.props.messages.selectedRecipient === null) {
      errorRecipient = this.state.recipients.length === 0 ? 'Please select a recipient' : null;  
    }
    let errorMessage = this.state.messageBody === '' ? 'Please enter a message' : null;

    if(errorRecipient === null &&
       errorMessage === null) {
      hasErrors = false;
    }

    this.setState({
      errorRecipient: errorRecipient,
      errorMessage: errorMessage,
    });

    return !hasErrors;
  }

  handleSubmit() {
    if(this.validateAll()) {

      if(this.props.messages.diamonds) {

        let diamond_ids = [];
        for(let i = 0; i < this.props.messages.diamonds.length; i++) {
          diamond_ids.push(this.props.messages.diamonds[i].id);
        }

        let recipient_ids = [];
        if(this.props.messages.selectedRecipient) {
          recipient_ids = [ this.props.messages.selectedRecipient.id ];
        } else {
          for(let i = 0; i < this.state.recipients.length; i++) {
            recipient_ids.push(this.state.recipients[i].id);
          }
        }

        let messageData = {
          recipients: recipient_ids,
          diamonds: diamond_ids,
          message_body: this.state.messageBody,
        }

        this.setState({
          sendingRequest: true,
          serverError: null,
        });

        this.props.messageSendShare(messageData)
        .then((respData) => {
          
          let confirmationMessage = 'The diamonds have been shared';
          if(diamond_ids.length == 1) {
            confirmationMessage = 'The diamond has been shared';
          }

          this.props.messagesCloseNewDropdown();
          this.props.messagesShowConfirmation(confirmationMessage);

          this.setState({
            sendingRequest: false,
            serverError: null,
            recipient: null,
            recipientInput: '',
            messageBody: '',
            errorRecipient: null,
            errorMessage: null,      
            displayAutocomplete: false,
            autocompleteUsers: [],
          });
        })
        .catch((errorResp) => {
          // console.error(errorResp);
          this.setState({
            sendingRequest: false,
            serverError: errorResp.message,
          });
        });

      } else {

        let recipient_ids = [];
        if(this.props.messages.selectedRecipient) {
          recipient_ids = [ this.props.messages.selectedRecipient.id ];
        } else {
          for(let i = 0; i < this.state.recipients.length; i++) {
            recipient_ids.push(this.state.recipients[i].id);
          }
        }
        
        let messageData = {
          recipients: recipient_ids,
          message_body: this.state.messageBody,
        }

        this.setState({
          sendingRequest: true,
          serverError: null,
        });

        this.props.messageSendSimple(messageData)
        .then((respData) => {
                  
          this.props.messagesCloseNewDropdown();
          this.props.messagesShowConfirmation();

          this.setState({
            sendingRequest: false,
            serverError: null,
            recipient: null,
            recipientInput: '',
            messageBody: '',
            errorRecipient: null,
            errorMessage: null,      
            displayAutocomplete: false,
            autocompleteUsers: [],
          });
        })
        .catch((errorResp) => {
          // console.error(errorResp);
          this.setState({
            sendingRequest: false,
            serverError: errorResp.message,
          });
        });
      }
    }
  }

  getRecipientDisplayName(recipient) {
    return recipient.first_name + ' ' + recipient.last_name;
  }

  getRecipientDisplayEmail(recipient) {
    return recipient.email;
  }

  getDropdownTitle() {
    return this.props.messages.diamonds ? 'Share With' : 'Send New Message';
  }

	render() {
		return <div className={this.getRootClass()}>
      <div className='innerWrapper'>
        <div className='closeIcon' onClick={this.props.messagesCloseNewDropdown.bind(this)}>&times;</div>
        <div className='newTitle'>{this.getDropdownTitle()}</div>
        <div className='recipientWrapper'>
          {this.props.messages.selectedRecipient !== null ?
            <div className='selectedRecipientList'>
              <div className='selectedRecipient'>
                <div className='nameWrapper'>{this.getRecipientDisplayName(this.props.messages.selectedRecipient)}</div>
                <div className='emailWrapper'>{this.getRecipientDisplayEmail(this.props.messages.selectedRecipient)}</div>
                {this.props.messages.selectedRecipient === null ?
                  <div className='removeRecipient' onClick={this.removeRecipient.bind(this)}>&times;</div> :
                  null
                }
              </div>
            </div> :
            <div className='selectedRecipientList'>
              {this.state.recipients.map((recipient, i) => {
                return <div className='selectedRecipient' key={i}>
                  <div className='nameWrapper'>{this.getRecipientDisplayName(recipient)}</div>
                  <div className='emailWrapper'>{this.getRecipientDisplayEmail(recipient)}</div>
                  {this.props.messages.selectedRecipient === null ?
                    <div className='removeRecipient' onClick={() => this.removeRecipient(recipient)}>&times;</div> :
                    null
                  }
                </div>
              })}
              {this.state.recipients.length > 0 && !this.state.displayInput?
                <div className='addNewLink' onClick={this.showInput.bind(this)}>Add New Recipient</div> :
                null
              }
            </div>
          }
          {this.state.displayInput ?
            <div>
              <input 
                type='text'
                className={this.state.errorRecipient ? 'messageInput error' : 'messageInput'}
                value={this.state.recipientInput}
                placeholder='First name, last name, email'
                onChange={this.changeRecipientInput.bind(this)}
                onFocus={this.openAutocomplete.bind(this)}
                onBlur={this.closeAutocomplete.bind(this)} />
              <div className={this.state.displayAutocomplete ? 'autocompleteWrapper open' : 'autocompleteWrapper'}>
                {this.state.autocompleteUsers.length === 0 ?
                  <div className={'autocompleteEntry nullAutocomplete'}>No matching users found</div> :
                  <div>
                    {this.state.autocompleteUsers.map((user, i) => {
                      return <div className='autocompleteEntry' onClick={() => this.selectRecipient(user)} key={i}>
                        <div className='nameWrapper'>{user.first_name + ' ' + user.last_name}</div>
                        <div className={'emailWrapper EllipsisElement'}>{user.email}</div>
                      </div>
                    })}
                  </div>
                }
              </div>
            </div> :
            null
          }
          
        </div>
        <div className='bodyWrapper'>
          <textarea
            placeholder = 'Message'
            className={this.state.errorMessage ? 'messageTextarea error' : 'messageTextarea'}
            onChange={this.changeMessage.bind(this)} 
            value={this.state.messageBody}
            onBlur={this.validateMessage.bind(this)}></textarea>
        </div>
        {this.props.messages.diamonds ?
          <div>
            {this.props.messages.diamonds.map((diamond, i) => {
              return <div className='diamondWrapper' key={i}>
                <div className='diamondImageWrapper'>
                  <img src={getDiamondImage(diamond)} />
                </div>
                <div className='diamondBodyWrapper'>
                  <div className='diamondTitle'>{formatDiamondTitle(diamond)}</div>
                  <div className='diamondMeasurementRow'>
                    {diamond.measurements ? 
                      <div className='diamondMeasurements'>{formatMeasurements(diamond)}</div> :
                      null
                    }
                    <div className='diamondLocation'>
                      <div className='diamondLocationIcon'>
                        <i className="fas fa-map-marker-alt"></i>
                      </div>
                      <div className='diamondLocationName'>{formatLocation(diamond)}</div>
                    </div>
                  </div>
                  <div className='diamondInfoBlock'>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Cut:</div>
                      <div className='diamondInfoValue'>{formatCut(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Lab:</div>
                      <div className='diamondInfoValue'>{diamond.lab}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Carat:</div>
                      <div className='diamondInfoValue'>{formatCarat(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Cost:</div>
                      <div className='diamondInfoValue'>{formatCost(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Color:</div>
                      <div className='diamondInfoValue'>{formatColor(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Price:</div>
                      <div className='diamondInfoValue'>{formatPrice(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>Clarity:</div>
                      <div className='diamondInfoValue'>{formatClarity(diamond)}</div>
                    </div>
                    <div className='diamondInfoItem'>
                      <div className='diamondInfoLabel'>{diamond.in_wallet ? 'Loose' : 'Mounted'}</div>
                      <div className='diamondInfoValue'></div>
                    </div>
                  </div>
                </div>
              </div>
            })}
          </div> :
          null
        }
        <div className='sendMessageWrapper'>
          <div 
            className={'actionButton sendButton'} 
            disabled={!this.state.sendingRequest} 
            onClick={this.handleSubmit.bind(this)}>Send</div>
        </div>
      </div>
    </div>;
	}
}
export default NewMessage;

function mapStateToProps(state) {
  return {
    messages: state.messages,
  };
}

export const NewMessageContainer = connect(
  mapStateToProps,
  allActionCreators
)(NewMessage);